import {
  RnCancel,
  RnCheckmark,
  RnPlay,
  RnRelation,
  RnReset,
  RnStatusDone,
  RnStatusInProgress,
  RnStatusOnHold,
  RnStatusWarning,
} from "@remi/icons/next";
import { ProjectStatus } from "@remi/types/project-status";

export const ProjectStatusIcons: Record<ProjectStatus, React.JSX.Element> = {
  [ProjectStatus.IN_PROGRESS]: <RnStatusInProgress size={"sm"} className="text-icon-teal" />,
  [ProjectStatus.URGENT]: <RnStatusWarning size={"sm"} className="text-icon-destructive" />,
  [ProjectStatus.REOPENED]: <RnReset size={"sm"} className="text-icon-secondary" />,
  [ProjectStatus.ON_HOLD]: <RnStatusOnHold size={"sm"} className="text-icon-yellow" />,
  [ProjectStatus.DONE]: <RnStatusDone size={"sm"} className="text-icon-success" />,
  [ProjectStatus.CANCELED]: <RnCancel size={"sm"} className="text-icon-tertiary" />,
  [ProjectStatus.CLOSED_LOST]: <RnCancel size={"sm"} className="text-icon-tertiary" />,
  [ProjectStatus.MERGED]: <RnRelation size={"sm"} className="text-icon-tertiary" />,
};

export const ContinueStatusIcons: Partial<Record<ProjectStatus, React.JSX.Element>> = {
  [ProjectStatus.ON_HOLD]: <RnPlay size={"sm"} className="text-icon-secondary" />,
  [ProjectStatus.CANCELED]: <RnPlay size={"sm"} className="text-icon-secondary" />,
  [ProjectStatus.CLOSED_LOST]: <RnPlay size={"sm"} className="text-icon-secondary" />,
  [ProjectStatus.URGENT]: <RnCheckmark size={"sm"} className="text-icon-success" />,
};
